// Base host of the static assets CDN. Every asset URL built in JS lives here so
// a domain migration is a one-line change instead of a search and replace.
// Plain CSS cannot read this constant, so the stylesheets that load the fonts,
// the wellet iconfont and the flags sprite still hardcode the same hosts and
// have to be updated with it: src/css/fonts.css, src/css/icon-wellet.css,
// src/css/slick.css, src/css/language-selector.css, src/css/purchase.css and
// src/components/Common/ErrorBox/ErrorBox.css.
export const CDN1_BASE = 'https://cdn1.wellet.mx';

export const errorIcon = `${CDN1_BASE}/images/exclamation-triangle.png`;

export const defaultOrganizationLogo = `${CDN1_BASE}/organizations/wellet/logo.png`;
